import { Amplify } from "aws-amplify";

import { productionConfig } from "./production";
import { stagingConfig } from "./staging";
import type { AmplifyAppConfig, AppEnv } from "./types";

export type {
  AmplifyAppConfig,
  AppEnv,
  RestApiEntry,
  DynamoTableEntry,
} from "./types";
export { stagingConfig } from "./staging";
export { productionConfig } from "./production";

const CONFIGS: Record<AppEnv, AmplifyAppConfig> = {
  staging: stagingConfig,
  production: productionConfig,
};

function resolveEnv(explicit?: AppEnv): AppEnv {
  if (explicit) return explicit;
  // Accessed as a direct, non-aliased `import.meta.env.NAME` expression (no
  // intermediate variable, no optional chaining) so Vite's build-time static
  // replacement can actually inline the value - anything else silently
  // evaluates to undefined at runtime in the production bundle.
  const fromAmplify = (
    (import.meta as { env: Record<string, string | undefined> }).env
      .AMPLIFY_APP_ENV_NAME ?? ""
  ).toLowerCase();
  if (fromAmplify === "production" || fromAmplify === "prod") return "production";
  return "staging";
}

/** The environment this build targets (`AMPLIFY_APP_ENV_NAME`, default staging). */
export function getAppEnv(): AppEnv {
  return resolveEnv();
}

export function getAmplifyConfig(env?: AppEnv): AmplifyAppConfig {
  return CONFIGS[resolveEnv(env)];
}

export function configureAmplify(env?: AppEnv): AmplifyAppConfig {
  const config = getAmplifyConfig(env);
  Amplify.configure(config);
  return config;
}
